/***
 * 创建人：yjs
 * 时间：2019-06-13
 * 描述：只能有英文字母和下划线组成,并且已英文字母开头
 * 更新记录: 
 */
import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[validatorParameterVerify]',
  providers:[{provide:NG_VALIDATORS,useExisting:forwardRef(()=>ValidatorParameterVerifyDirective),multi:true}]
})
export class ValidatorParameterVerifyDirective {

  constructor() { }
  validate(control:AbstractControl):any{
    let valid:boolean = false
    var reg = /^[A-Za-z][A-Za-z_]{0,}$/
    if(!control.value){
      valid = true  //为空时不校验
    } else{
      valid = reg.test(control.value)
    }
    return valid ? null:  {parameterVerify:"只包含英文和下划线并且只能已英文开头"}   //结果符合时,返回null,不符合时,返回对象进行提示
  }
}